import React from 'react';
import { Box, Typography, Button, Container, Divider } from '@mui/material';
import appStoreBadge from '../assets/app-store-badge.svg';
import playStoreBadge from '../assets/play-store-badge.png';
declare global {
  interface Window {
    appInsights: any;
  }
}

const Home: React.FC = () => {

  const handleButtonClick = (store: string) => {
    if (window.appInsights) {
      window.appInsights.trackEvent({
        name: 'AppDownloadButtonClick',
        properties: {
          store: store,                     
          page: document.title,
          referrer: document.referrer
        }
      });
    }
  };

  return (
    <Container
      maxWidth="md"
      sx={{
        marginTop: 4,
        marginBottom: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Typography
        variant="h2"
        gutterBottom
        sx={{
          fontFamily: 'Montserrat',
          textAlign: 'center',
          color: 'dodgerblue',
        }}
      >
        Where America Comes To Poll
      </Typography>

      <Divider
        sx={{
          width: '100%',
          borderColor: 'dodgerblue',
          borderWidth: 1,
          mb: 2,
        }}
      />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 4,
          width: '100%',
        }}
      >

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 2,
            justifyContent: 'center',
          }}
        >
          <Button
            component="a"
            href="https://apps.apple.com/us/app/american-polling-machine/id6670273172"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => handleButtonClick('App Store')}
            sx={{
              p: 0,
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'transparent',
                boxShadow: 'none',
              },
            }}
          >
            <img
              src={appStoreBadge}
              alt="Download on the App Store"
              style={{ height: '60px', width: 'auto' }}
            />
          </Button>

          <Button
            component="a"
            href="https://play.google.com/store/apps/details?id=com.letspoll.apm"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => handleButtonClick('Google Play')}
            sx={{
              p: 0,
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'transparent',
                boxShadow: 'none',
              },
            }}
          >
            <img
              src={playStoreBadge}
              alt="Get it on Google Play"
              style={{ height: '60px', width: 'auto' }}
            />
          </Button>
        </Box>

        <Box
          component="video"
          controls
          autoPlay
          muted
          playsInline
          loop
          src="https://apm90ed.blob.core.windows.net/videos/ScrollingAPM.mp4?sp=r&st=2025-06-07T13:37:01Z&se=2099-06-07T21:37:01Z&spr=https&sv=2024-11-04&sr=c&sig=AIigNxlkNQjY9rwcVe7019Nt53O%2FiFFUCa1UHf2RbA0%3D"
          sx={{
            display: 'block',
            mx: 'auto',
            borderRadius: 3,
            width: '100%',
            maxWidth: 300,
            border: '2px solid dodgerblue',
          }}
        />
      </Box>
    </Container>
  );
};

export default Home;
